<template>
  <talentq-controller v-if="loaded" />
  <error-view v-else-if="error" :error="error" @reload="load" />
  <vpreloader v-else width="2" size="64" />
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import ErrorView from '@/process/_components/error-view';
  import { TALENTQ_STORE_NAMES } from '@/stores_new/vacancy_talentq/constants';
  import TalentqController from './controllers/talentq';
  import store from './stores';

  const { mapActions, mapGetters } = createNamespacedHelpers(
    'vacancy_talentq/' + TALENTQ_STORE_NAMES.BINDING
  );

  export default {
    name: 'Talentq',

    components: {
      TalentqController,
      ErrorView
    },

    mixins: [store],

    computed: {
      ...mapGetters(['loaded', 'error'])
    },

    created() {
      this.load();
    },

    methods: {
      ...mapActions(['load'])
    }
  };
</script>
